<template>
    <div class="treeview theme--light">
        <TreeItem
            v-for="item in items"
            :key="item.id"
            :item="item"
            :selected="value"
            :level="0"
            :load-children="loadChildren"
            :parent-ids="[]"
            :leaf-level="leafLevel"
            @select="onSelect"
        />
    </div>
</template>

<script>
import TreeItem from '@/components/treeView/TreeItem.vue';

export default {
    name: 'TreeView',
    components: { TreeItem },
    props: {
        items: {
            type: Array,
            required: true
        },
        value: {
            type: Array,
            'default': () => []
        },
        loadChildren: {
            type: Function
        },
        leafLevel: {
            type: Number
        }
    },
    methods: {
        onSelect (item) {
            const index = this.value.findIndex(s => s.id === item.id);
            let newValue;
            if (index === -1) {
                newValue = [...this.value, item];
            } else {
                newValue = this.value.filter(s => s.id !== item.id);
            }
            this.$emit('input', newValue);
        }
    }
};
</script>

<style scoped>
@import "./styles.css";
</style>
